import React from 'react';
import ProductSidebarComponent from './ProductSidebarComponent';
import { PageHeader } from '../../components';

const BoilerWaterTreatment: React.FC = () => {
  return (
    <>
      <PageHeader title="Boiler Water Treatment – SANYOL® WT Series" breadcrumbs={[{ label: "Products", path: "/products" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-3.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-1.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">Boiler Water Treatment – SANYOL® WT Series</h1>
              
              <h3 className="mb-4">Overview</h3>
              <p>Boiler water treatment chemicals are essential for protecting steam systems from corrosion, scaling, and carryover. At Wasser Technochem (India) Ltd., we offer a comprehensive range of SANYOL® WT Boiler Treatment Solutions, including both conventional phosphate-based and modern AVT (All Volatile Treatment) programs. These are specially formulated for industries using WHRBs, CFBC, package boilers, and utility boilers. With proven AVT programs running in leading cement and power industries such as Ultratech and Shree Cement, our specialty chemicals have not only improved system health but also delivered significant cost savings.</p>
              <p>Our solutions are designed to optimize heat transfer, prevent downtime, and ensure long-term boiler reliability, all while complying with IS, ASME, and OEM guidelines.</p>

              <h3 className="mb-4">Applications</h3>
              <p><i className="fa fa-fire text-primary me-2"></i>Waste Heat Recovery Boilers (WHRB)</p>
              <p><i className="fa fa-industry text-primary me-2"></i>CFBC & AFBC Boilers</p>
              <p><i className="fa fa-cube text-primary me-2"></i>Package Boilers (Oil/Gas/Dual Fuel)</p>
              <p><i className="fa fa-bolt text-primary me-2"></i>Power Plant Utility Boilers</p>
              <p><i className="fa fa-building text-primary me-2"></i>Textile, Paper, Chemical, and Cement industries</p>

              <h3 className="mb-4">Product Range (SANYOL® WT)</h3>
              
              <h4 className="mb-3"><i className="fa fa-shield-alt text-primary me-2"></i>Oxygen Scavengers:</h4>
              <p><i className="fa fa-circle text-secondary me-2"></i>DEHA, Hydrazine-based, and catalyzed sulphite blends</p>

              <h4 className="mb-3"><i className="fa fa-balance-scale text-primary me-2"></i>Alkalinity Builders:</h4>
              <p><i className="fa fa-circle text-secondary me-2"></i>Morpholine, Cyclohexylamine, Ammonia-based AVT blends</p>

              <h4 className="mb-3"><i className="fa fa-filter text-primary me-2"></i>Scale Inhibitors & Dispersants:</h4>
              <p><i className="fa fa-circle text-secondary me-2"></i>For phosphate and non-phosphate systems</p>

              <h4 className="mb-3"><i className="fa fa-vial text-primary me-2"></i>AVT (Filming Amines & Neutralizing Amines):</h4>
              <p><i className="fa fa-circle text-secondary me-2"></i>Ideal for systems prone to FAC (Flow Accelerated Corrosion)</p>

              <h4 className="mb-3"><i className="fa fa-tint text-primary me-2"></i>Condensate Line Treatments:</h4>
              <p><i className="fa fa-circle text-secondary me-2"></i>Neutralizing amines and pH boosters</p>

              <h3 className="mb-4">Features & Benefits</h3>
              <p><i className="fa fa-check-circle text-success me-2"></i>Prevents scale and corrosion in boiler & condensate lines</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Enhances boiler efficiency and fuel economy</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Reduces blowdown losses and water wastage</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Protects expensive assets like BFPs, turbines, and headers</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>AVT options reduce oxygen attack without solid residues</p>

              <h3 className="mb-4">Why WTIL?</h3>
              <p><i className="fa fa-star text-warning me-2"></i>Customized treatment plans based on feedwater and metallurgy</p>
              <p><i className="fa fa-star text-warning me-2"></i>AVT programs for high-pressure boilers, including ACC systems</p>
              <p><i className="fa fa-star text-warning me-2"></i>On-site monitoring, lab backup, and dosing audits</p>
              <p><i className="fa fa-star text-warning me-2"></i>Products tested and approved across textile, cement, and power sectors</p>
              <p className="mb-5"><i className="fa fa-star text-warning me-2"></i>Proven to reduce downtime and tube failures in over 100+ installations</p>
            </div>

            <div className="col-lg-4">
              <ProductSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default BoilerWaterTreatment;
